import { atom } from 'recoil';

export const businessData = atom({
    key: 'businessData', // unique ID (with respect to other atoms/selectors)
    default: localStorage.getItem('business')&&localStorage.getItem('business') !== "undefined" ? JSON.parse(localStorage.getItem('business')) : null,
    // default value (aka initial value)
});
export const businessId = atom({
    key: 'businessId', // unique ID (with respect to other atoms/selectors)
    default: null,
    // default value (aka initial value)
});

export const locationData = atom({
    key: 'locationData', // unique ID (with respect to other atoms/selectors)
    default: {
        location_name: '',
        location_phone_no: '',
        location_address: '',
        street: '',
        city: '',
        state: '',
        zipCode: '',
        form_status: '',
    },
    // default value (aka initial value)
});

export const locationDataList = atom({
    key: 'locationDataList', // unique ID (with respect to other atoms/selectors)
    default: [],
    // default value (aka initial value)
});

export const selectedLocation = atom({
    key: 'selectedLocation', // unique ID (with respect to other atoms/selectors)
    default: {},
    // default value (aka initial value)
});

export const locationList = atom({
    key: 'locationList', // unique ID (with respect to other atoms/selectors)
    default: [],
    // default value (aka initial value)
});

export const userDetails = atom({
    key: 'useDetails', // unique ID (with respect to other atoms/selectors)
    default: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : [],
    // default value (aka initial value)
});

export const isAutheticated = atom({
    key: 'isAutheticated', // unique ID (with respect to other atoms/selectors)
    default: null,
    // default value (aka initial value)
});
export const errorsState = atom({
    key: 'errorsState',
    default: {
        name: '',
        contact_number: '',
        email: '',
    },
});
export const SelectedPatient = atom({
    key: 'SelectedPatient',
    default: {},
});
export const UserRoleAtom = atom({
    key: 'useRoleAtom',
    default: localStorage.getItem('userRole') ? localStorage.getItem('userRole') : '',
});

export const ViewInvoiceDetail = atom({
    key: 'invoiceDetail',
    default: {},
});
